import { NavigationContainerRef } from "@react-navigation/native";
import { trackScreenView } from "../analyticsUtil";

let previousRouteKey: string | null = null;

export const trackNavigation = (
  navigationRef: NavigationContainerRef<any>
) => {
  if (!navigationRef.isReady()) return;
  const route = navigationRef.getCurrentRoute();
  if (!route) return;

  const screenName = route.name;
  const params = route.params ?? {};

  // allow retrigger when params change
  const routeKey = `${screenName}:${JSON.stringify(params)}`;
  if (routeKey === previousRouteKey) return;

  previousRouteKey = routeKey;

  trackScreenView(screenName, params);
};

// Fires screen_view unconditionally on app foreground — bypasses the
// duplicate-route guard so re-opens to the same screen are counted in DAU.
export const trackAppForeground = (
  navigationRef: NavigationContainerRef<any>
) => {
  if (!navigationRef.isReady()) return;
  const route = navigationRef.getCurrentRoute();
  if (!route) return;

  const params = route.params ?? {};
  previousRouteKey = `${route.name}:${JSON.stringify(params)}`;
  trackScreenView(route.name, params);
};
